export class LoadReleaseNotes {
  static readonly type = '[ReleaseNotes] LoadReleaseNotes';
}

export class LoadRecentReleaseNote {
  static readonly type = '[ReleaseNotes] LoadRecentReleaseNote';
}
